export default "__VITE_ASSET__92c18e2b__"